var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2748.304,
    height: 1884.896,
    viewBox: "0 0 2748.304 1884.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#faeee9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7e7ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.678 -1095.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M501.2,0c283.253,0,512.875,229.622,512.875,512.875S784.458,1025.749,501.2,1025.749-254.276,629.973,182.739,512.875,217.952,0,501.2,0Z",
    transform: "translate(1243.547 1095.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.169,0C228.568,0,5.148,223.419,5.148,499.021S228.568,998.042,504.169,998.042s735.074-385.086,309.863-499.021S779.771,0,504.169,0Z",
    transform: "translate(-495.826 1982.674)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/Shapes.b9aeeea5daa6bea711b1e087769ab2ec.svg";
export { ForwardRef as ReactComponent };